import {Category} from '../types/category';
import {Product} from '../types/product';

export const products: Product[] = [
  {
    name: 'Bife 1ª Kg',
    price: 38.49,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/bifeprimeira.png',
    countable: false,
  },
  {
    name: 'Musculo Kg',
    price: 34.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/musculobovino.png',
    countable: false,
  },
  {
    name: 'Peito Kg',
    price: 23.49,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/peitobovino.png',
    countable: false,
  },
  {
    name: 'Lombo Kg',
    price: 22.49,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/lombobovino.png',
    countable: false,
  },
  {
    name: 'Coxão Mole Kg',
    price: 39.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/coxaomole.png',
    countable: false,
  },
  {
    name: 'Bife Patinho Kg',
    price: 38.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/bifepatinho.png',
    countable: false,
  },
  {
    name: 'Costela Kg',
    price: 21.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/costela.png',
    countable: false,
  },
  {
    name: 'Bife Molho Kg',
    price: 37.49,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/bifemolho.png',
    countable: false,
  },
  {
    name: 'Filé Mignon Kg',
    price: 59.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/filemignon.png',
    countable: false,
  },
  {
    name: 'Bisteca 1ª Kg',
    price: 35.49,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/bistecaprimeira.png',
    countable: false,
  },
  {
    name: 'Capa Filé Kg',
    price: 29.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/capafile.png',
    countable: false,
  },
  {
    name: 'Fraldinha Kg',
    price: 34.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/fraldinha.png',
    countable: false,
  },
  {
    name: 'Figado Kg',
    price: 21.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/figado.png',
    countable: false,
  },
  {
    name: 'Carne de Sol Kg',
    price: 38.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/carnedesol.png',
    countable: false,
  },
  {
    name: 'Mão de Vaca Kg',
    price: 18.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/maovaca.png',
    countable: false,
  },
  {
    name: 'Mocotó Kg',
    price: 13.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/mocoto.png',
    countable: false,
  },
  {
    name: 'Bucho Kg',
    price: 27.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/bucho.png',
    countable: false,
  },
  {
    name: 'Bife Especial Kg',
    price: 34.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/bifeespecial.png',
    countable: false,
  },
  {
    name: 'Picadinho Kg',
    price: 34.49,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/picadinho.png',
    countable: false,
  },
  {
    name: 'Carne Moída 1ª',
    price: 29.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/carnemoidaprimeira.png',
    countable: false,
  },
  {
    name: 'Carne Moída 2ª',
    price: 21.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/carnemoidasegunda.png',
    countable: false,
  },
  {
    name: 'Osso Buco Kg',
    price: 24.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/ossobuco.png',
    countable: false,
  },
  {
    name: 'Chambaril Kg',
    price: 6.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/chambaril.png',
    countable: false,
  },
  {
    name: 'Carré Suino Kg',
    price: 17.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte suino fresco.',
    image: '/assets/images/images_list/carre.png',
    countable: false,
  },
  {
    name: 'Costela Suina',
    price: 25.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte suino fresco.',
    image: '/assets/images/images_list/costelasuina.png',
    countable: false,
  },
  {
    name: 'Cupim Kg',
    price: 49.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/cupim.png',
    countable: false,
  },
  {
    name: 'Paleta Kg',
    price: 22.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/paleta.png',
    countable: false,
  },
  {
    name: 'Maminha Kg',
    price: 43.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/maminha.png',
    countable: false,
  },
  {
    name: 'Alcatra Kg',
    price: 42.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/alcatra.png',
    countable: false,
  },
  {
    name: 'Picanha Kg',
    price: 54.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/picanha.png',
    countable: false,
  },
  {
    name: 'Strogonoff Kg',
    price: 35.49,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/strogonoff.png',
    countable: false,
  },
  {
    name: 'Coração Kg',
    price: 12.99,
    enabled: true,
    category: Category.Carnes,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/coracao.png',
    countable: false,
  },
  {
    name: 'Picanha Suína Merci Kg',
    price: 29.99,
    enabled: true,
    category: Category.Congelados,
    description: 'Corte suíno.',
    image: '/assets/images/images_list/picanhasuinamerci.png',
    countable: false,
  },
  {
    name: 'Maminha Argentina Pilotti',
    price: 54.99,
    enabled: true,
    category: Category.Congelados,
    description: 'Corte bovino kg.',
    image: '/assets/images/images_list/maminhaargentinapilotti.png',
    countable: false,
  },
  {
    name: 'Cupim Maturatta Friboi',
    price: 51.99,
    enabled: true,
    category: Category.Congelados,
    description: 'Corte bovino kg.',
    image: '/assets/images/images_list/cupimmaturatafriboi.png',
    countable: false,
  },
  {
    name: 'Bananinha Friboi Kg',
    price: 41.99,
    enabled: true,
    category: Category.Congelados,
    description: 'Corte bovino fresco.',
    image: '/assets/images/images_list/bananinhafriboi.png',
    countable: false,
  },
  {
    name: 'Ling Nabrasa Toscana 1Kg',
    price: 30.99,
    enabled: true,
    category: Category.Congelados,
    description: 'Embutidos.',
    image: '/assets/images/images_list/toscananabrasa1kg.png',
    countable: true,
  },
  {
    name: 'Ling Mista Gostosinha 700g',
    price: 7.49,
    enabled: true,
    category: Category.Congelados,
    description: 'Embutidos.',
    image: '/assets/images/images_list/lingmistagostosinha700g.png',
    countable: true,
  },
  {
    name: 'Carne Moida Gostosinha 500g',
    price: 6.89,
    enabled: true,
    category: Category.Congelados,
    description: 'Carne bovina.',
    image: '/assets/images/images_list/moidagostosinha500g.png',
    countable: true,
  },
  {
    name: 'Hamburguer Rezende 56g',
    price: 1.50,
    enabled: true,
    category: Category.Congelados,
    description: 'Embutido.',
    image: '/assets/images/images_list/hambrezende56g.png',
    countable: true,
  },
  {
    name: 'Hamburguer Sadia 56g',
    price: 1.50,
    enabled: true,
    category: Category.Congelados,
    description: 'Embutido.',
    image: '/assets/images/images_list/hambsadia56g.png',
    countable: true,
  },
  {
    name: 'Hamburguer Friboi 56g',
    price: 10.49,
    enabled: true,
    category: Category.Congelados,
    description: 'Embutido.',
    image: '/assets/images/images_list/hambfriboi56g.png',
    countable: true,
  },
  {
    name: 'Peito Tijuca 1Kg',
    price: 19.39,
    enabled: true,
    category: Category.Aves,
    description: 'Cortes ave congelada.',
    image: '/assets/images/images_list/peitotijucabdj.png',
    countable: true,
  },
  {
    name: 'Sassami Tijuca 1Kg',
    price: 21.89,
    enabled: true,
    category: Category.Aves,
    description: 'Cortes ave congelada.',
    image: '/assets/images/images_list/sassamitijucabdj.png',
    countable: true,
  },
  {
    name: 'Coxa/Sobrecoxa Tijuca 1Kg',
    price: 12.49,
    enabled: true,
    category: Category.Aves,
    description: 'Cortes ave congelada.',
    image: '/assets/images/images_list/coxasobrecoxatijucabdj.png',
    countable: true,
  },
  {
    name: 'Sobrecoxa Tijuca 1Kg',
    price: 12.49,
    enabled: true,
    category: Category.Aves,
    description: 'Cortes ave congelada.',
    image: '/assets/images/images_list/sobrecoxatijucabdj.png',
    countable: true,
  },
  {
    name: 'Filé Peito Tijuca 1Kg',
    price: 22.99,
    enabled: true,
    category: Category.Aves,
    description: 'Cortes ave congelada.',
    image: '/assets/images/images_list/filepeitotijuca.png',
    countable: true,
  },
  {
    name: 'Coxinha Asa Tijuca 1Kg',
    price: 17.49,
    enabled: true,
    category: Category.Aves,
    description: 'Cortes ave congelada.',
    image: '/assets/images/images_list/coxinhaasatijucabdj.png',
    countable: true,
  },
  {
    name: 'Coxa Tijuca 1Kg',
    price: 12.99,
    enabled: true,
    category: Category.Aves,
    description: 'Cortes ave congelada.',
    image: '/assets/images/images_list/coxatijucabdj.png',
    countable: true,
  },
  {
    name: 'Figado Tijuca 1Kg',
    price: 7.49,
    enabled: true,
    category: Category.Aves,
    description: 'Cortes ave congelada.',
    image: '/assets/images/images_list/figadotijucabdj.png',
    countable: true,
  },
  {
    name: 'Moela Tijuca 1Kg',
    price: 9.99,
    enabled: true,
    category: Category.Aves,
    description: 'Cortes ave congelada.',
    image: '/assets/images/images_list/moelatijucabdj.png',
    countable: true,
  },
  {
    name: 'Queijo Coalho Kg',
    price: 33.80,
    enabled: true,
    category: Category.Frios,
    description: 'Frios Fresco.',
    image: '/assets/images/images_list/queijocoalho.png',
    countable: false,
  },
  {
    name: 'Queijo Mussarela Kg',
    price: 39.00,
    enabled: true,
    category: Category.Frios,
    description: 'Frios Fresco.',
    image: '/assets/images/images_list/queijomussarela.png',
    countable: false,
  },
  {
    name: 'Apresuntado Rezende Kg',
    price: 22.79,
    enabled: true,
    category: Category.Frios,
    description: 'Frios Fresco.',
    image: '/assets/images/images_list/apresuntadorezende.png',
    countable: false,
  },
  {
    name: 'Presunto Rezende Kg',
    price: 20.80,
    enabled: true,
    category: Category.Frios,
    description: 'Frios Fresco.',
    image: '/assets/images/images_list/presuntorezende.png',
    countable: false,
  },
  {
    name: 'Mortadela Mista Gostosinha 1kg',
    price: 8.99,
    enabled: true,
    category: Category.Frios,
    description: 'Embutido.',
    image: '/assets/images/images_list/mortgostosinha1kg.png',
    countable: true,
  },
  {
    name: 'Mortadela Frango Gostosinha 1Kg',
    price: 8.99,
    enabled: true,
    category: Category.Frios,
    description: 'Embutido.',
    image: '/assets/images/images_list/mortfrangogostosinha1kg.png',
    countable: true,
  },
  {
    name: 'Mortadela Mista Gostosinha Kg',
    price: 8.49,
    enabled: true,
    category: Category.Frios,
    description: 'Embutido.',
    image: '/assets/images/images_list/mortgostosinhakgmista.png',
    countable: false,
  },
  {
    name: 'Mortadela Frango Gostosinha Kg',
    price: 8.49,
    enabled: true,
    category: Category.Frios,
    description: 'Embutido.',
    image: '/assets/images/images_list/mortgostosinhafrangokg.png',
    countable: false,
  },
  {
    name: 'Mortadela Mista Confiança 1kg',
    price: 9.99,
    enabled: true,
    category: Category.Frios,
    description: 'Embutido.',
    image: '/assets/images/images_list/mortconfmista1kg.png',
    countable: true,
  },
  {
    name: 'Mortadela Mista Confiança Kg',
    price: 11.29,
    enabled: true,
    category: Category.Frios,
    description: 'Embutido.',
    image: '/assets/images/images_list/mortconfmistakg.png',
    countable: false,
  },
  {
    name: 'Pepperoni Seara 100g',
    price: 10.79,
    enabled: true,
    category: Category.Frios,
    description: 'Embutido.',
    image: '/assets/images/images_list/peperoniseara100g.png',
    countable: true,
  },
  {
    name: 'Ling Calabresa Merci 360g',
    price: 8.99,
    enabled: true,
    category: Category.Frios,
    description: 'Embutido.',
    image: '/assets/images/images_list/lingmerci360g.png',
    countable: true,
  },
  {
    name: 'Ling Calabresa Gostosinha 360g',
    price: 7.19,
    enabled: true,
    category: Category.Frios,
    description: 'Embutido.',
    image: '/assets/images/images_list/linggostosinha360g.png',
    countable: true,
  },
  {
    name: 'Jerked Beef Minerva 400g',
    price: 14.99,
    enabled: true,
    category: Category.Frios,
    description: 'Carne salgada.',
    image: '/assets/images/images_list/jbminerva400g.png',
    countable: true,
  },
  {
    name: 'Oleo Soja Soya 900ml',
    price: 7.99,
    enabled: true,
    category: Category.Mercearia,
    description: 'Oleo Soja.',
    image: '/assets/images/images_list/oleosoya900ml.png',
    countable: true,
  },
  {
    name: 'Sal Jacaré 1Kg',
    price: 0.99,
    enabled: true,
    category: Category.Mercearia,
    description: 'Sal refinado.',
    image: '/assets/images/images_list/saljacare1kg.png',
    countable: true,
  },
  {
    name: 'Sal Grosso Marfim 1kg',
    price: 1.0,
    enabled: true,
    category: Category.Mercearia,
    description: 'Sal grosso.',
    image: '/assets/images/images_list/salgrossomarfim1kg.png',
    countable: true,
  },
  {
    name: 'Arroz Branco Alteza 1Kg',
    price: 7.50,
    enabled: true,
    category: Category.Mercearia,
    description: 'Arroz Branco.',
    image: '/assets/images/images_list/arrozbrancoalteza1kg.png',
    countable: true,
  },
  {
    name: 'Leite Pó Ninho 380G',
    price: 16.99,
    enabled: true,
    category: Category.Mercearia,
    description: 'Leite Pó Lata.',
    image: '/assets/images/images_list/leiteponinho380glt.png',
    countable: true,
  },
  {
    name: 'Leite Pó Itambé 200g',
    price: 6.70,
    enabled: true,
    category: Category.Mercearia,
    description: 'Leite Pó.',
    image: '/assets/images/images_list/leitepoitambe200g.png',
    countable: true,
  },
  {
    name: 'Leite Betânia Integral 1L',
    price: 5.79,
    enabled: true,
    category: Category.Mercearia,
    description: 'Leite Líquido.',
    image: '/assets/images/images_list/leitebetania1l.png',
    countable: true,
  },
  {
    name: 'Leite Maranguape Integral 1L',
    price: 5.39,
    enabled: true,
    category: Category.Mercearia,
    description: 'Leite Líquido.',
    image: '/assets/images/images_list/leitemaranguape1l.png',
    countable: true,
  },
  {
    name: 'Leite Condensado Italac 395g',
    price: 5.85,
    enabled: true,
    category: Category.Mercearia,
    description: 'Leite Condensado.',
    image: '/assets/images/images_list/leitecondensadoitalac395g.png',
    countable: true,
  },
  {
    name: 'Creme Leite Betânia 200g',
    price: 3.49,
    enabled: true,
    category: Category.Mercearia,
    description: 'Creme de Leite.',
    image: '/assets/images/images_list/cremeleitebetania200g.png',
    countable: true,
  },
  {
    name: 'Creme Leite Italac 200g',
    price: 3.89,
    enabled: true,
    category: Category.Mercearia,
    description: 'Creme de Leite.',
    image: '/assets/images/images_list/cremeleiteitalac200g.png',
    countable: true,
  },
  {
    name: 'Milho Verde Só Fruta 170g',
    price: 3.20,
    enabled: true,
    category: Category.Mercearia,
    description: 'Milho verde.',
    image: '/assets/images/images_list/milhoverdesofruta170g.png',
    countable: true,
  },
  {
    name: 'Biscoito Sortidos Doce 400g',
    price: 4.69,
    enabled: true,
    category: Category.Mercearia,
    description: 'Biscoito Fortaleza.',
    image: '/assets/images/images_list/biscoitosortidosdoce400g.png',
    countable: true,
  },
  {
    name: 'Biscoito Mini Cracker 400g',
    price: 4.59,
    enabled: true,
    category: Category.Mercearia,
    description: 'Biscoito Fortaleza.',
    image: '/assets/images/images_list/biscminicracker400g.png',
    countable: true,
  },
  {
    name: 'Macarrão Richester 400g',
    price: 5.99,
    enabled: true,
    category: Category.Mercearia,
    description: 'Macarrão Spahetti.',
    image: '/assets/images/images_list/macspagrich400g.png',
    countable: true,
  },
  {
    name: 'Macarrão Bonsabor 400g',
    price: 2.69,
    enabled: true,
    category: Category.Mercearia,
    description: 'Macarrão Spahetti.',
    image: '/assets/images/images_list/macbonsabor400g.png',
    countable: true,
  },
  {
    name: 'Macarrão Estrela 400g',
    price: 4.49,
    enabled: true,
    category: Category.Mercearia,
    description: 'Macarrão Parafuso.',
    image: '/assets/images/images_list/macparafusoestrela400g.png',
    countable: true,
  },
  {
    name: 'Massa Tapioca Precioso 1Kg',
    price: 6.59,
    enabled: true,
    category: Category.Mercearia,
    description: 'Massa Tapioca.',
    image: '/assets/images/images_list/massatapiocaprecioso1kg.png',
    countable: true,
  },
  {
    name: 'Extrato Alho Regina 500ml',
    price: 4.39,
    enabled: true,
    category: Category.Temperos,
    description: 'Extrato de Alho.',
    image: '/assets/images/images_list/extratoalhoregina500ml.png',
    countable: true,
  },
  {
    name: 'Vinagre Sadio 500ml',
    price: 1.19,
    enabled: true,
    category: Category.Temperos,
    description: 'Vinagre.',
    image: '/assets/images/images_list/vinagresadio500.png',
    countable: true,
  },
  {
    name: 'Temp Completo Da Roça 250g',
    price: 2.29,
    enabled: true,
    category: Category.Temperos,
    description: 'Sem pimenta.',
    image: '/assets/images/images_list/tdacsp295g.png',
    countable: true,
  },
  {
    name: 'Temp Sazon 60g Frango',
    price: 4.79,
    enabled: true,
    category: Category.Temperos,
    description: 'Tempero.',
    image: '/assets/images/images_list/tempsazon60gfrango.png',
    countable: true,
  },
  {
    name: 'Temp Sazon 60g Massas',
    price: 4.79,
    enabled: true,
    category: Category.Temperos,
    description: 'Tempero.',
    image: '/assets/images/images_list/tempsazon60massas.png',
    countable: true,
  },
  {
    name: 'Paprica Doce 115g Da Roça',
    price: 9.49,
    enabled: true,
    category: Category.Temperos,
    description: 'Tempero.',
    image: '/assets/images/images_list/daroca115gpapdoce.png',
    countable: true,
  },
  {
    name: 'Salsa 30g Da Roça',
    price: 8.19,
    enabled: true,
    category: Category.Temperos,
    description: 'Tempero.',
    image: '/assets/images/images_list/salsa120gdaroca.png',
    countable: true,
  },
  {
    name: 'Kit Carnes',
    price: 10.50,
    enabled: true,
    category: Category.Kits,
    description: 'Kit.',
    image: '/assets/images/images_list/kit.png',
    countable: true,
  },
];
